import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PrefacturaStatus from '../../support/enum/PrefacturaStatus';

class PrefacturasItemStatus extends Component {

  get config() {
    const { data: { status } } = this.props;

    const prefactura = PrefacturaStatus.search(status);

    let variant = '';
    let icon = 'circle';

    if (prefactura.isPending()) {
      variant = 'warning';
      icon = 'clock';
    } else if (prefactura.isCancelled()) {
      variant = 'danger';
      icon = 'circle';
    } else if (prefactura.isSuccess()) {
      variant = 'success';
      icon = 'circle';
    }

    return {
      icon,
      variant
    }
  }

  render() {
    const { icon, variant } = this.config;

    return (
      <span className={ `badge-rounded text-${variant}` }>
        <FontAwesomeIcon icon={ ['fas', icon] } />
      </span>
    )
  }
}

export default PrefacturasItemStatus;